/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ErrorCode } from '../models/ErrorCode';
import { Initiator } from '../models/Initiator';
import { JobStatus } from '../models/JobStatus';

export class JobExecutionDetails {
  /**
  * Job ID.
  */
  'jobId': string;
  'status': JobStatus;
  /**
  * Date and time the job was created.
  */
  'createdTime': Date;
  /**
  * Date and time the job is expected to start. Returned only for pending jobs. 
  */
  'expectedStartTime'?: Date | null;
  /**
  * Date and time the job started.
  */
  'startTime'?: Date | null;
  /**
  * Date and time the job finished.
  */
  'endTime'?: Date | null;
  /**
  * How long the job took, in seconds.
  */
  'durationSeconds'?: number | null;
  'errorCode'?: ErrorCode | null;
  /**
  * Message that gives additional details about the job status, if applicable.
  */
  'statusMessage'?: string;
  /**
  * Whether the job is on demand (by user or by BP)
  */
  'isOnDemand'?: boolean;
  'onDemandInitiator'?: Initiator;
  /**
  * The date the job was last updated
  */
  'updatedTime'?: Date;
  /**
  * The ID of the snapshot
  */
  'snapshotId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobId",
      "baseName": "jobId",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "JobStatus",
      "format": ""
    },
    {
      "name": "createdTime",
      "baseName": "createdTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "expectedStartTime",
      "baseName": "expectedStartTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "startTime",
      "baseName": "startTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "endTime",
      "baseName": "endTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "durationSeconds",
      "baseName": "durationSeconds",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "errorCode",
      "baseName": "errorCode",
      "type": "ErrorCode",
      "format": ""
    },
    {
      "name": "statusMessage",
      "baseName": "statusMessage",
      "type": "string",
      "format": ""
    },
    {
      "name": "isOnDemand",
      "baseName": "isOnDemand",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "onDemandInitiator",
      "baseName": "onDemandInitiator",
      "type": "Initiator",
      "format": ""
    },
    {
      "name": "updatedTime",
      "baseName": "updatedTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return JobExecutionDetails.attributeTypeMap;
  }

  public constructor() {
  }
}



